import React from "react";
import { Link } from "react-router-dom";
import boxOpen from "../images/boxOpen.svg";
import { useTranslation } from 'react-i18next';


export default function JoinSuccess(){
    const { t } = useTranslation();
    
    return(
        <div className="joinSuccess">  
            <div className="loginArea">
                <div className="hs40"></div>
                <div className="dfColG20 pd20 content">
                    <img src={boxOpen} alt="축하합니다"/>
                    <ul className="dfColG12">
                        <li><h3 className="fw700 fs20">{t(`Message.sign_up_complate_msg1`)}</h3></li>
                        <li>
                            <p>{t(`Message.sign_up_complate_msg2`)}</p>
                            <p>{t(`Message.sign_up_complate_msg3`)}</p>
                            <p>{t(`Message.sign_up_complate_msg4`)}</p>
                        </li>
                    </ul>
                </div>
                <div className="pl20 pr20">
                    <Link to="/LogIn" className="btn48 orgB cFFF">{t(`Message.sign_up_complate_move_login`)}</Link>
                </div>
            </div>
        </div>
    );
};